//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'product-modifier',
  props: [
    'modifiers',
    'modMap',
    'onAddModifier',
    'activeModifier',
    'setActiveMod'
  ],
  methods: {
    addModifier(mod, id, q = 1) {
      this.onAddModifier(mod, id, q)
    },
    setModifierGroup(id) {
      let el = document.getElementById('mod_'+id)
      setTimeout(function() {
        let scrollTop = window.scrollY + el.getBoundingClientRect().top
        window.scroll({top: scrollTop-12, left: 0, behavior: 'smooth'})
      }, 100)
      // console.log('setModifierGroup', id)
      this.setActiveMod(id)
    }
  }
}
